import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const ScrollTo = props => {
  const { condition, scrollToDivDirectly } = props;
  const divRef = useRef(null);

  useEffect(() => {
    if (condition && scrollToDivDirectly) {
      const bodyRect = document.body.getBoundingClientRect();
      const divRect = divRef.current.getBoundingClientRect();
      const offsetTop = divRect.top - bodyRect.top;

      window.scroll({ top: offsetTop, behavior: 'smooth' });
    } else if (condition) {
      const bodyRect = document.body.getBoundingClientRect();
      const divRect = divRef.current.getBoundingClientRect();
      const offsetTop = divRect.top - bodyRect.top;

      window.scroll({
        top: offsetTop - 16, // Theme.spacing(2) = 1rem and therefore cannot be used for calculation
        behavior: 'smooth'
      });
    }
  }, [condition, scrollToDivDirectly]);

  return <div ref={divRef} />;
};

ScrollTo.propTypes = {
  condition: PropTypes.any,
  /** Sometimes we just want to scroll to the div without any calculation */
  scrollToDivDirectly: PropTypes.bool
};

export default ScrollTo;
